// "use client";
// import React, { useEffect, useContext } from "react";
// import Navigation from "@/components/navbar";
// import Header from "@/components/header";
// import Footer from "@/components/footer";
// import { useSelector, useDispatch } from "react-redux";
// import { fetchCategories } from "@/redux/slices/categorySlice";
// import { usePathname } from "next/navigation";
// import { LoaderContext } from "@/contexts/LoaderContext";

// export default function Layout({ children }) {
//   const pathName = usePathname();
//   const dispatch = useDispatch();
//   // const category = useSelector((state) => state.categories.categories);
//   const { showLoader, hideLoader, isLoading } = useContext(LoaderContext);

//   // useEffect(() => {
//   //   dispatch(fetchCategories());
//   // }, [dispatch]);

//   const shouldHideNavigation =
//     pathName === "/login" ||
//     pathName === "/register" ||
//     pathName === "/forgot-password" ||
//     pathName === "/reset-password" ||
//     pathName === "/verification";
//   return (
//     <main
//   className={`main-content h-100 ${shouldHideNavigation ? "bg-shape-loginflow" : ""}`}
// >
//       {!shouldHideNavigation && <Header/>}
//        <Navigation />

//       {/* Show loader between navigation and footer */}
//       <div className="content-area" style={{ minHeight: "60vh" }}>
//         {isLoading ? (
//           <div className="d-flex justify-content-center align-items-center">
//             <div className="loader"></div>
//           </div>
//         ) : (
//           <div>{children}</div>
//         )}
//       </div>

//       {!shouldHideNavigation && <Footer />}
//     </main>
//   );
// }
"use client";
import React, { useEffect, useContext } from "react";
import Navigation from "@/components/navbar";
import Header from "@/components/header";
import Footer from "@/components/footer";
import { useDispatch } from "react-redux";
import { usePathname } from "next/navigation";
import { LoaderContext } from "@/contexts/LoaderContext";
import { fetchCategories } from "@/redux/slices/categorySlice";
import CustomToast from "../custom-toast/CustomToast";
import { ToastProvider } from "@/contexts/ToastContext";

export default function Layout({ children }) {
  const pathName = usePathname();
  const dispatch = useDispatch();
  const { showLoader, hideLoader, isLoading } = useContext(LoaderContext);

  useEffect(() => {
    dispatch(fetchCategories());
  }, [dispatch]);

  const shouldHideNavigation =
    pathName === "/login" ||
    pathName === "/register" ||
    pathName === "/forgot-password" ||
    pathName === "/reset-password" ||
    pathName === "/verification";

  return (
    <ToastProvider>
      <main
        className={`main-content h-100 ${
          shouldHideNavigation ? "bg-shape-loginflow" : ""
        }`}
      >
        {!shouldHideNavigation && <Header />}

        <Navigation />
        <CustomToast />
        <div className="content-area" style={{ minHeight: "60vh" }}>
          {isLoading ? (
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ minHeight: "300px" }}
            >
              <div className="loader"></div>
            </div>
          ) : (
            <div>{children}</div>
          )}
        </div>

        {!shouldHideNavigation && <Footer />}
      </main>
    </ToastProvider>
  );
}
